import React, { useEffect, useState } from 'react';
import { get } from "lodash";

import languages from "../../common/languages";

const LanguageDropdown = () => {
    const [selectedLang, setSelectedLang] = useState("fr");

    useEffect(() => {
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE") || "fr";
        const isValid = currentLanguage && Object.keys(languages).includes(currentLanguage);
        setSelectedLang(isValid ? currentLanguage : "fr");
    }, []);

    return (
        <div
            className="ms-1 topbar-head-dropdown header-item d-flex align-items-center"
            title="Langue (verrouillée)"
            style={{ cursor: "not-allowed", opacity: 0.85 }}
        >
            <span className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle pe-none">
                <img
                    src={get(languages, `${selectedLang}.flag`)}
                    alt="Langue"
                    height="20"
                    className="rounded"
                />
            </span>
        </div>
    );
};

export default LanguageDropdown;